import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/esnext.iterator.map.js";
import { __decorate } from "tslib";
// Prop、Watch、Emit、Model、Inject
import { Component, Vue } from 'vue-property-decorator';
// import { Getter, Action } from 'vuex-class'
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import { getBargain as _getBargain, getBargainUser as _getBargainUser, bargaining as _bargaining } from '@/services/http';
import QRCode from 'qrcodejs2';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import { Mutation } from 'vuex-class';
import { readCookie } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    // @Getter('xxx') xxx: any
    // @Action('xxx') xxx!: Function
    // activated() {}
    _this = _callSuper(this, default_1, arguments);
    _this.bargainingList = []; // 砍价中列表
    _this.bargainList = []; // 砍价商品列表
    _this.bargainUser = []; // 砍价参与用户
    _this.dialogVisible = false; // 二维码弹窗控制
    _this.qrcode = ''; // 二维码
    _this.qrcodeUrl = ''; // 二维码地址
    _this.productId = '';
    _this.mySwiper = '';
    _this.pageNo = 1;
    _this.totalnumber = 0;
    _this.pageSize = 15;
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.init();
    }
  }, {
    key: "handleCurrentChange",
    value: function handleCurrentChange(val) {
      this.pageNo = val;
      this.getBargain();
    }
  }, {
    key: "handleSizeChange",
    value: function handleSizeChange(val) {
      this.pageSize = val;
      this.getBargain();
    }
    // 初始化
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!readCookie('accessToken')) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return this.bargaining();
            case 3:
              _context.next = 5;
              return this.getBargain();
            case 5:
              _context.next = 7;
              return this.getBargainUser();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }() // 去付款
  }, {
    key: "goOrderConfirm",
    value: function goOrderConfirm(item) {
      var confirmlist = [{
        freight: null,
        productId: item.productId,
        id: item.productPriceId,
        mallImage: {
          source_url: item.product.listImagePath.sourceUrl,
          product_name: item.product.productName
        },
        natureList: item.natureList,
        num: 1,
        price: (item.originalAmount - item.bargainAmount).toFixed(2),
        totalPrice: (item.originalAmount - item.bargainAmount).toFixed(2)
      }];
      this.CONFIRMORDER(confirmlist);
      this.$router.push("/orderconfirm?type=2&configId=".concat(item.configId, "&bargain=bargain"));
    }
    // 打开二维码弹窗
  }, {
    key: "openDialog",
    value: function openDialog(id) {
      var _this2 = this;
      this.productId = id;
      this.dialogVisible = true;
      this.qrcodeUrl = process.env.VUE_APP_BASE_API;
      this.$nextTick(function () {
        _this2.$refs.qrCodeUrl.innerHTML = '';
        _this2.qrcode = new QRCode(_this2.$refs.qrCodeUrl, {
          text: "".concat(process.env.VUE_APP_BASE_API, "/m/bargaining?id=").concat(_this2.productId),
          width: 180,
          height: 180,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    }
    // 获取砍价中列表
  }, {
    key: "bargaining",
    value: function () {
      var _bargaining2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3 = this;
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _bargaining({
                companyId: 1
              });
            case 2:
              res = _context2.sent;
              if (res.data && res.data.code === 100) {
                this.bargainingList = res.data.data.map(function (item) {
                  var data = item;
                  data.hour = Math.floor(data.surplus / 3600) < 10 ? "0".concat(Math.floor(data.surplus / 3600)) : Math.floor(data.surplus / 3600);
                  data.minute = Math.floor(data.surplus / 60 % 60) < 10 ? "0".concat(Math.floor(data.surplus / 60 % 60)) : Math.floor(data.surplus / 60 % 60);
                  data.second = Math.floor(data.surplus % 60) < 10 ? "0".concat(Math.floor(data.surplus % 60)) : Math.floor(data.surplus % 60);
                  if (data.surplus > 0) {
                    var timer = setInterval(function () {
                      if (data.hour === '00' && data.minute === '00' && data.second === '00') {
                        clearInterval(timer);
                        _this3.$router.go(0);
                        return;
                      }
                      data.hour = Math.floor(data.surplus / 3600) < 10 ? "0".concat(Math.floor(data.surplus / 3600)) : Math.floor(data.surplus / 3600);
                      data.minute = Math.floor(data.surplus / 60 % 60) < 10 ? "0".concat(Math.floor(data.surplus / 60 % 60)) : Math.floor(data.surplus / 60 % 60);
                      data.second = Math.floor(data.surplus % 60) < 10 ? "0".concat(Math.floor(data.surplus % 60)) : Math.floor(data.surplus % 60);
                      data.surplus -= 1;
                    }, 1000);
                  }
                  return data;
                });
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function bargaining() {
        return _bargaining2.apply(this, arguments);
      }
      return bargaining;
    }() // 获取砍价列表
  }, {
    key: "getBargain",
    value: function () {
      var _getBargain2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var anchor, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              anchor = readCookie('anchor');
              _context3.next = 3;
              return _getBargain({
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                companyId: 1,
                model: anchor ? anchor.model : '',
                equipVersion: anchor ? anchor.equipVersion : '',
                equipMeid: anchor ? anchor.equipMeid : ''
              });
            case 3:
              res = _context3.sent;
              if (res.data && res.data.code === 100) {
                this.bargainList = res.data.data.list ? res.data.data.list : [];
                this.totalnumber = res.data.data.total;
                this.bargainList = this.bargainList.map(function (item) {
                  var data = item;
                  if (data.lowest_price.split(',')[0]) {
                    // const lowPrice = data.lowest_price.split(',')[0].split('.')[0];
                    // const lowPrice2 = data.lowest_price.split(',')[0].split('.')[1];
                    // data.lowPrice = lowPrice - data.bargain_amount;
                    // data.lowPrice2 = lowPrice2;
                    var lowPrice = ((data.lowest_price.split(',')[0] || data.lowest_price) - data.bargain_amount).toFixed(2).toString();
                    data.lowPrice = lowPrice.substring(0, lowPrice.indexOf('.'));
                    data.lowPrice2 = lowPrice.substring(lowPrice.indexOf('.') + 1, lowPrice.length);
                  }
                  return data;
                });
              }
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getBargain() {
        return _getBargain2.apply(this, arguments);
      }
      return getBargain;
    }() // 获取参与情况
  }, {
    key: "getBargainUser",
    value: function () {
      var _getBargainUser2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this4 = this;
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _getBargainUser({
                num: 10,
                companyId: 1
              });
            case 2:
              res = _context4.sent;
              if (res.data.code === 100) {
                this.bargainUser = res.data.data.slice(0, 20);
                this.$nextTick(function () {
                  _this4.mySwiper = new Swiper('.swiper-container', {
                    autoplay: 5000,
                    direction: 'vertical',
                    speed: 500
                  });
                });
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getBargainUser() {
        return _getBargainUser2.apply(this, arguments);
      }
      return getBargainUser;
    }() // 复制成功
  }, {
    key: "onCopy",
    value: function onCopy() {
      this.$message.success('复制成功');
    }
    // 复制失败
  }, {
    key: "onError",
    value: function onError() {
      this.$message.error('该浏览器不支持自动复制，请手动复制');
    }
  }]);
}(Vue);
__decorate([Mutation('order/CONFIRMORDER')], default_1.prototype, "CONFIRMORDER", void 0);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer
  }
})], default_1);
export default default_1;